// extracted by mini-css-extract-plugin
export default {"awsHeading":"EnterpriseFooter_awsHeading__1+1Ns","root":"EnterpriseFooter_root__atOn3"};